/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import cn from 'classnames';
import { Box, Grid, Typography } from '@material-ui/core';
import useStyles from './useStyles';

const TableLookup = ({ tables, onChooseTable, selectedTable }) => {
  const classes = useStyles();
  return (
    <Grid container className={cn(classes.gridContainer, classes.scrollYContainer)}>
      {tables.map(eachTable =>
        <Grid item key={`key-${eachTable?.id}`} xs={6} sm={6} md={4} lg={3}>
          <Box
            m={0.5}
            py={2}
            px={1}
            onClick={() => onChooseTable(eachTable)}
            className={cn(classes.gridBox, { [classes.selectedTool]: selectedTable?.id === eachTable?.id })}
          >
            <Typography variant='body2' className={cn({ [classes.selectedTxt]: selectedTable?.id === eachTable?.id })}>#{eachTable?.number}</Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default TableLookup;
